import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { AnimatePresence, motion } from "framer-motion";
import CardWithNumber from "../generic/CardWithNumber";

const HowItWorks = () => {
  const howItWorksItems = [
    {
      number: 1,
      title: "Seamless Integration",
      subtitle: "Easily Connect with Your Existing Platform",
      description:
        "Integrate our messaging system effortlessly into your current platform, ensuring a smooth and seamless connection with no disruption to your existing workflows.",
    },

    {
      number: 2,
      title: "Brand Customization",
      subtitle: "Tailor Alerts to Match Your Brand’s Voice",
      description:
        "Customize notifications and alerts to align with your brand’s unique voice and design, ensuring your messages feel personal and on-brand every time.",
    },
    {
      number: 3,
      title: "Consistent Cross-Channel Notifications",
      subtitle: "Reach Users Across All Channels",
      description:
        "Deliver notifications consistently through push, in-app, and inbox channels, ensuring your users are always informed, no matter how they interact with your platform.",
    },
    {
      number: 4,
      title: "Enhanced User Engagement",
      subtitle: "Fewer Missed Alerts, Greater Impact",
      description:
        "Improve user engagement by reducing missed alerts. Our system ensures that users are always in the loop, leading to more effective communication and higher satisfaction.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"HowItWorks"}>
        <Line>
          <TextWrapper>
            <Title>How it Works</Title>
          </TextWrapper>
        </Line>
        <ItemsWrapper>
          {howItWorksItems.map((item, index) => (
            <CardWithNumber
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              description={item.description}
              number={item.number}
            />
          ))}
        </ItemsWrapper>
      </Container>
    </FullPageContainer>
  );
};

export default HowItWorks;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;

  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  @media (max-width: 990px) {
    gap: 30px;
    flex-direction: column;
  }
`;
const ItemsWrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 40px;
  height: 100%;
  @media (max-width: 990px) {
    display: flex;
    flex-direction: column;
  }
`;
